export { AccountPage as Account } from './account';
